import { useEffect } from 'react';

import { fg } from '@confluence/feature-gating';
import { createSingleQueryParamHook } from '@confluence/route-manager/entry-points/RouteState.ts';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

const useShowRecap2025QueryParam = createSingleQueryParamHook('showRecap2025');

export const useRecapSidebarCollapse = (): boolean => {
	const isEditorPage = useIsEditorPage();
	const showRecap2025QueryParam = useShowRecap2025QueryParam();
	const isLivePage = useIsCurrentPageLive();

	const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isEditorPage;

	// Check if user has already collapsed the sidebar for recap before
	const hasCollapsedBefore =
		confluenceLocalStorageInstance &&
		confluenceLocalStorageInstance.getItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_RECAP_SIDEBAR_COLLAPSED,
		) === 'true';

	const shouldCollapse = isEligible && !hasCollapsedBefore && fg('cc_recap_2025_sidebar_collapse');

	// Set the persisted flag when we determine we should collapse
	// This marks that the user has seen this behavior (first visit)
	useEffect(() => {
		if (shouldCollapse && confluenceLocalStorageInstance) {
			confluenceLocalStorageInstance.setItem(
				PERSISTED_KEYS_ON_SERVER.PERSISTED_RECAP_SIDEBAR_COLLAPSED,
				'true',
			);
		}
	}, [shouldCollapse]);

	return shouldCollapse;
};
